import axios from "axios";
import store from "../store/store.js";
import router from "../router.js";
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});
apiClient.interceptors.response.use(
    function(response) {

        if (response == undefined || response.status >= 400) {
            // to assure all kind of errors won't fail with invalid code, i check every step if it's undefined,
            // if so go straight to the pre-defined message. if it's defined and there's a field 'customresponse'
            // then there's a message coming back from the backend and should display in this code block. 
            if (response != undefined &&
                response.data != undefined &&
                errorResponse.response.data.hasOwnProperty('customresponse')) {
                store.dispatch("addNotification", {
                    type: "failure",
                    Message: response.data.message
                })
            } else {
                store.dispatch("addNotification", {
                    type: "failure",
                    Message: "An error has occurred."
                })
            }
            return Promise.reject("we rejected the promise in the HTTP interceptor, see file EventService.js");
        }

        return response;
    },
    function(errorResponse) {

        // to assure all kind of errors won't fail with invalid code, i check every step if it's undefined,
        // if so go straight to the pre-defined message. if it's defined and there's a field 'customresponse'
        // then there's a message coming back from the backend and should display in this code block. 
        if (errorResponse != undefined &&
            errorResponse.response != undefined &&
            errorResponse.response.data != undefined &&
            errorResponse.response.data.hasOwnProperty('customresponse')) {
            store.dispatch("addNotification", {
                type: "failure",
                Message: errorResponse.response.data.message
            })
        }
        // this is for a specific error that should be displayed in the form and not as a notification. we throw the exception
        // the error string "confirm email address error", the component login.vue checks in the catch block for this string 
        // and displays a message in the form
        else if (errorResponse != undefined &&
            errorResponse.response != undefined &&
            errorResponse.response.data != undefined &&
            errorResponse.response.data.error_description == "can not sign in. please confirm your email address with the link sent to your email") {
            return Promise.reject("confirm email address error");
        } else {
            store.dispatch("addNotification", {
                type: "failure",
                Message: "An error has occurred."
            })
        }

        return Promise.reject("we rejected the promise in the HTTP interceptor, see file EventService.js");
    }
);
// apiClient.interceptors.response.use(
//   function(response) {
//     return response;
//   },
//   function(error) {
//     console.log("hello from error part of interceptor " + error);
//     if (error.status == 401) {
//       console.log("hello from inside interceptor if statement");
//       router.push({ name: "Login" });
//     }
//     return Promise.reject(error);
//   }
// );
// const apiPictureUpload = axios.create({
//   baseURL: process.env.VUE_APP_API_URL,
//   withCredentials: false,
//   headers: {
//     "Content-Type": "multipart/form-data"
//   }
// });

// eslint-disable-next-line no-unused-vars
function checkif402(statuscode) {
    if (statuscode == 402) {
        router.push("/Subscription");
    }
}
export default {
    // TESTS
    test401() {
        return apiClient.get(
            `api/Property/SingleProperty?propertyid=b45c0bda-432c-43de-9d1e-6be0a012a506`
        );
    },

    // USER SECTION
    Register(info) {
        return apiClient.post("/api/Account/Register", info);
    },
    ConfirmEmailFromRegistration(userid, token) {
        return apiClient.post(
            `/api/Account/ConfirmEmail?userId=${userid}&token=${token}`
        );
    },
    ResendRegistrationConfirmationEmail(email) {
        return apiClient.get(
            `/api/Account/RequestConfirmEmailToken?email=${email}`
        );
    },
    token(credentials) {
        return apiClient.post("/token", credentials);
    },

    refreshUsersToken(refreshToken) {
        return apiClient.post("/token", refreshToken)
    },

    logOut() {
        /// logout with the authenitcation token and then delete it
        apiClient.post("/api/Account/Logout");
        (function revokeAuthorization() {
            delete apiClient.defaults.headers.common["Authorization"];
        })();
    },
    getCurrentUserProfile() {
        return apiClient.get("/api/Account/CurrentUserInfo");
    },
    getUserImage(userId) {
        return apiClient.get(`api/account/userimage?userid=${userId}`);
    },
    updateProfile(profiledata, userId) {
        return apiClient.put(`/api/Account/Update/${userId}`, profiledata);
    },
    updatePassword(updatepassworddata) {
        return apiClient.put("/api/Account/ChangePassword", updatepassworddata);
    },
    resetPassword(email) {
        return apiClient.post("/api/Account/RequestEmailToResetPassword", email);
    },
    ConfirmEmailFromPasswordReset(userid, token, newpasswordobject) {
        return apiClient.post(
            `/api/Account/ResetPasswordFromEmailLink?userid=${userid}&token=${token}`,
            newpasswordobject
        );
    },
    getMyContacts() {
        return apiClient.get("/api/Contact/MyContacts");
    },
    assignContact(issueid, userid) {
        return apiClient.post(`/api/Issue/AssignIssue?issueid=${issueid}&userid=${userid}`);
    },
    changeIssueDueDate(issueId, dueDate) {
        return apiClient.post(`/api/issue/ChangeIssueDueDate?issueid=${issueId}&duedate=${dueDate}`);
    },
    unassignContact(issueid) {
        return apiClient.put(`/api/Issue/UnassignIssue?issueid=${issueid}`);
    },

    searchForContact(searchedContact) {
        return apiClient.get(`/api/Contact/SearchUsers?query=${searchedContact}`);
    },
    addToMyContacts(userid) {
        return apiClient.post(`/api/Contact/AddContact?userid=${userid}`);
    },
    deleteMyContact(contactid) {
        return apiClient.delete(
            `/api/Contact/RemoveContact?contactid=${contactid}`
        );
    },
    postFeedback(feedbackdata, isLoggedIn) {
        return apiClient.post(`/api/FeedBack?loggedin=${isLoggedIn}`, feedbackdata);
    },
    getInbox() {
        return apiClient.get("/api/Inbox/GetInboxMessage");
    },
    getUserIssues(userid, type, status) {
        return apiClient.get(
            `/api/issue/IssuesForUsers?userid=${userid}&type=${type}&status=${status}`

        );
    },

    generateIssueReportForUser() {
        return apiClient.get(
            // `/api/issue/IssuesForUsers?userid=${userid}&type=${type}&status=${status}`
            `/api/issue/GenerateIssueReports`
        );
    },

    ///////////////////////////////////
    ////////////// Property/////////
    ///////////////////////////////////
    getAllProperties() {
        return apiClient.get("/api/Property/AllProperties");
    },
    getAllPropertiesBasicInfo(userid) {
        return apiClient.get(`/api/Property/AllPropertiesBasicInfo?userid=${userid}`);
    },
    getPermissionsForProperties(propertyids, privilegeName) {
        return apiClient.post(`/api/permissions/PermissionsForProperties?privilegename=${privilegeName}`, propertyids);
    },
    GetPropertiesMachinesBasicInfo(propertyid) {
        return apiClient.get(`/api/Machine/GetPropertiesMachinesBasicInfo?propertyid=${propertyid}`);
    },
    getPropertybyId(PropertyId) {
        return apiClient.get(
            `api/Property/SingleProperty?propertyid=${PropertyId}`
        );
    },

    getTechMachineRestrictions(propertyId, techuserid) {
        return apiClient.get(
            `/api/MachineRestriction?propertyid=${propertyId}&userid=${techuserid}`
        );
    },
    addProperty(propertydata) {
        return apiClient.post("/api/Property", propertydata).catch(function(error) {
            if (error.response.status == 402) {
                router.push({ name: "Subscription" });
            }
        });
    },
    UpdateTechMachineRestrictions(propertyid, userid, machinerestrictiondata) {
        return apiClient.post(
            `/api/MachineRestriction?propertyid=${propertyid}&userid=${userid}`,
            machinerestrictiondata
        );
    },
    GetSpecificPropertyCsvFile(propertyid) {
        console.log("get specific property csv file in eventservice is running");
        return apiClient.get(`/api/CsvFile?propertyid=${propertyid}`);
    },
    UploadSpecificPropertyCsvFile(propertyid, formData) {
        return apiClient.post(`/api/CsvFile?propertyid=${propertyid}`, formData);
    },
    GetIssuesOfProperty(propertyid, status) {
        return apiClient.get(
            `/api/issue/IssuesForProperty?propertyid=${propertyid}&status=${status}`
        );
    },
    ///////////////////////////////////
    ////////////// Invite User/////////
    ///////////////////////////////////
    getPropertyInvitedUsers(PropertyId) {
        return apiClient.get(
            `/api/InviteUser/GetUsersLinkedToProperty?propertyid=${PropertyId}`
        );
    },
    getMachineInvitedUsers(MachineId) {
        return apiClient.get(
            `/api/InviteUser/GetUsersLinkedToMachine?machineid=${MachineId}`
        );
    },
    getPropertyCustomFields(propertyId) {
        return apiClient.get(
            `/GetCustomFieldTitlesForProperty?propertyid=${propertyId}`
        );
    },

    getUsersLinkedToUser(userid) {
        return apiClient.get(
            `/api/InviteUser/GetUsersLinkedToUser?userid=${userid}`

        )
    },

    InviteUserToProperty(PropertyIdsObject, email, roleid) {
        return apiClient.post(
            `/api/InviteUser/InviteUsersToProperties?emailaddress=${email}&roleid=${roleid}`,
            PropertyIdsObject
        );
    },
    ChangeUserRoleForProperty(PropertyId, userid, rolename) {
        return apiClient.post(
            `/api/InviteUser/ChangeUserRoleForProperty?propertyid=${PropertyId}&userid=${userid}&rolename=${rolename}`
        );
    },
    RemoveUserFromPropertyByEmail(propertyid, email) {
        return apiClient.delete(
            `/api/InviteUser/RemoveUserFromProperty?propertyid=${propertyid}&email=${email}&userid=null`
        );
    },
    RemoveUserFromPropertyByUserId(propertyid, userid) {
        return apiClient.delete(
            `/api/InviteUser/RemoveUserFromProperty?propertyid=${propertyid}&userid=${userid}&email=null`
        );
    },
    UserLeaveProperty(propertyid, userid) {
        return apiClient.delete(
            `/api/InviteUser/UserLeaveProperty?propertyid=${propertyid}&userid=${userid}`
        );
    },

    // Machines and LOGS
    getMachinesofProperty(PropertyId) {
        return apiClient.get(`/api/machine/ForProperty?propertyid=${PropertyId}`);
    },
    getSingleMachineInfo(machineid) {
        return apiClient.get(`/api/machine/SingleMachine?machineid=${machineid}`);
    },
    getLogsofMachine(MachineId) {
        return apiClient.get(`/api/log/ForMachine?machineid=${MachineId}`);
    },
    getLogsofIssue(IssueId) {
        return apiClient.get(`/api/log/ForIssue?issueid=${IssueId}`);
    },
    getListOfIssuePriorities() {
        return apiClient.get(`/api/IssuePriorities/GetListOfIssuePriorities`);
    },
    changeIssuePriority(issueId, priorityId) {
        return apiClient.put(`/api/issue/ChangeIssuePriority?issueid=${issueId}&priorityid=${priorityId}`)
    },
    getIssuesofMachine(MachineId, status) {
        return apiClient.get(
            `/api/Issue/IssuesForMachine?machineid=${MachineId}&status=${status}`
        );
    },
    getIssuebyId(IssueId) {
        return apiClient.get(`/api/log/ForIssue?issueid=${IssueId}`);
    },
    getRecurringIssueHistory(maintenanceId) {
        return apiClient.get(`api/issue/RecurringIssueHistory?maintenanceid=${maintenanceId}`)
    },
    setAuthorization(access_token) {
        apiClient.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${access_token}`;
        //apiPictureUpload.defaults.headers.common[
        //  "Authorization"
        //] = `Bearer ${access_token}`;
    },
    adminGetDifferentUserToken(userEmail) {
        return apiClient.get(`api/Account/LoginAs?userName=${userEmail}`)
    },
    GenerateImageObjectSpaceOnAws(picturedetailsobject) {
        return apiClient.post(
            "/api/ImageHandler/GenerateImageObject",
            picturedetailsobject
        );
    },
    uploadPictureToAws(presignedurl, file, contenttype, cacheTime) {
        return axios.put(presignedurl, file, {
            headers: {
                "Content-Type": contenttype,
                "Cache-Control": `max-age=${cacheTime}`
            },
        });
    },
    GenerateFileObjectSpaceOnAws(filedetailsobject) {
        return apiClient.post(
            "/api/FileHandler/GenerateFileObject",
            filedetailsobject
        );
    },
    uploadFileToAws(presignedurl, file, contenttype, filename, cacheTime) {
        return axios.put(presignedurl, file, {
            headers: {
                "Content-Type": contenttype,
                "Content-Disposition": `attachment;filename=${filename}`,
                "Cache-Control": `max-age=${cacheTime}`
            },
        });
    },

    addAsset(assetdata) {
        return apiClient.post("/api/machine", assetdata).catch(function(error) {
            if (error.response.status == 402) {
                router.push({ name: "Subscription" });
            }
        });
    },
    addLog(logdata) {
        return apiClient.post("/api/log", logdata);
    },
    addIssue(issuedata) {
        return apiClient.post("/api/issue/PostIssue", issuedata);
    },
    createTemplate(templateContentAndInfo) {
        return apiClient.post("/api/TextEditerTemplate/CreateTemplate", templateContentAndInfo);
    },
    getTemplatesForIssue(issueid) {
        return apiClient.get(`api/TextEditerTemplate/GetAllTemplatesforIssue?issueid=${issueid}`)
    },
    updateTemplate(templateId, templateData) {
        return apiClient.put(`/api/TextEditerTemplate/UpdateTemplate?templateid=${templateId}`, templateData);
    },
    deleteTemplate(templateId) {
        return apiClient.delete(`/api/TextEditerTemplate/DeleteTemplate?templateid=${templateId}`)
    },
    updateProperty(Propertyid, Propertydata) {
        return apiClient.put(`/api/Property/${Propertyid}`, Propertydata);
    },
    updateAsset(assetid, assetdata) {
        return apiClient.put(`/api/machine/${assetid}`, assetdata);
    },
    updateLog(logId, logdata) {
        return apiClient.put(`/api/log/${logId}`, logdata);
    },
    updateIssue(issueId, issuedata) {
        return apiClient.put(
            `/api/issue/UpdateIssue?issueid=${issueId}`,
            issuedata
        );
    },
    getSingleIssue(issueid) {
        return apiClient.get(`/api/issue/IssueDetails?issueid=${issueid}`)
    },
    deleteProperty(PropertyId) {
        return apiClient.delete(`/api/Property/${PropertyId}`);
    },
    deleteAsset(assetId) {
        return apiClient.delete(`/api/machine/${assetId}`);
    },
    deleteLog(logId) {
        return apiClient.delete(`/api/log/${logId}`);
    },
    deleteIssue(issueId) {
        return apiClient.delete(`/api/issue/DeleteIssue?issueid=${issueId}`);
    },
    getUsersAllMachines() {
        return apiClient.get(`/api/machine/GetUsersMachines`);
    },
    ///////////////////////////////////
    ////////////// Qr /////////
    ///////////////////////////////////
    CheckQrAssociateStatus(qrurl) {
        return apiClient.get(`/api/QrCode/CheckAssociateStatus?qrurl=${qrurl}`);
    },
    associateQrToAsset(qrurl, machineid) {
        return apiClient.post(`/api/QrCode/AssociateQrToAsset?qrurl=${qrurl}&machineid=${machineid}`);

    },
    closeIssue(issueid) {
        return apiClient.post(`/api/issue/CloseIssue?issueid=${issueid}`);
    },
    reopenIssue(issueid) {
        return apiClient.post(`/api/issue/ReopenIssue?issueid=${issueid}`)
    },
    getUserInfo(userid) {
        return apiClient.get(`/api/Account/UserInfoById?userid=${userid}`)
    },
    getUsersUnreadsAmount() {
        return apiClient.get(`/api/Inbox/GetInboxMessageCountForUser`)
    },
    markInboxMsgsRead(msgIds) {
        return apiClient.put(`/api/Inbox`, msgIds)
    },
    getAllRoles(propertyid) {
        return apiClient.get(`/api/UserRole/GetRoles?propertyid=${propertyid}`)
    },
    getPermissionsModel() {
        return apiClient.get(`/api/UserRole/GetPrivilegeModel`)
    },
    createNewPermission(permissionsObject) {
        return apiClient.post(`/api/UserRole/CreateRole`, permissionsObject)
    },
    editRoleForUser(propertyId, userId, roleid) {
        return apiClient.put(`/api/InviteUser/ChangeUserRoleForProperty?propertyid=${propertyId}&userid=${userId}&roleid=${roleid}`)
    },
    getSingleRoleDetails(roleId) {
        return apiClient.get(`/api/UserRole/GetPrivilegesForRole?roleid=${roleId}`)
    },
    editPriviligesOfRole(roleId, roleName, permissions) {
        return apiClient.put(`/api/UserRole/EditRolesPrivileges?roleid=${roleId}&rolename=${roleName}`, permissions)
    },
    deleteRole(deleteRoleid, addRoleId) {
        return apiClient.delete(`/api/UserRole/DeleteRole?deleteroleid=${deleteRoleid}&addroleid=${addRoleId}`)
    },
    dummyCreateMaintenance(schedule) {
        return apiClient.post(`/api/MaintenanceDummy/createmaintenance`, schedule)
    },
    dmmyGetMaintenance(machineId, fromDate) {
        return apiClient.get(`/api/MaintenanceDummy/getmaintenance?machineid=${machineId}&fromdate=${fromDate}`)
    },
    dummyUpdateMaintenance(maintenanceId, maintenanceDetails) {
        return apiClient.put(`/api/MaintenanceDummy/updatemaintenance?maintenanceid=${maintenanceId}`, maintenanceDetails)
    },
    dummyCompleteMaintenance(maintenanceId) {
        return apiClient.put(`/api/MaintenanceDummy/completemaintenance?maintenanceid=${maintenanceId}`)
    },
    dummyDeleteMaintenance(maintenanceId) {
        return apiClient.delete(`/api/MaintenanceDummy/deletemaintenance?maintenanceid=${maintenanceId}`)
    }
};